export default __webpack_public_path__ + "static/jamstack-5318eb706670affb25e8c5d96eb4858f.png";